'use strict';

exports.__esModule = true;
var WORKING_HOURS = exports.WORKING_HOURS = {
  LOAD: 'WORKING_HOURS_LOAD',
  LOAD_SUCCESS: 'WORKING_HOURS_LOAD_SUCCESS',
  LOAD_DONE: 'WORKING_HOURS_LOAD_DONE',
  LOAD_FAIL: 'WORKING_HOURS_LOAD_FAIL',
  SAVE: 'WORKING_HOURS_SAVE',
  SAVE_SUCCESS: 'WORKING_HOURS_SAVE_SUCCESS',
  SAVE_DONE: 'WORKING_HOURS_SAVE_DONE',
  SAVE_FAIL: 'WORKING_HOURS_SAVE_FAIL',
  GET_BRANCH_WORKING_HOURS: {
    FETCH: 'GET_BRANCH_WORKING_HOURS_FETCH',
    SUCCESS: 'GET_BRANCH_WORKING_HOURS_SUCCESS',
    FAIL: 'GET_BRANCH_WORKING_HOURS_FAIL'
  },
  SET_BRANCH_WORKING_HOURS: {
    SUBMIT: 'SET_BRANCH_WORKING_HOURS_SUBMIT',
    SUCCESS: 'SET_BRANCH_WORKING_HOURS_SUCCESS',
    FAIL: 'SET_BRANCH_WORKING_HOURS_FAIL'
  },
  WORKING_HOURS: {
    SUBMIT: 'WORKING_HOURS_SUBMIT',
    SUCCESS: 'WORKING_HOURS_SUBMIT_SUCCESS',
    FAIL: 'WORKING_HOURS_SUBMIT_FAIL'
  }
};

var loadWorkingHours = exports.loadWorkingHours = function loadWorkingHours(doctors, rooms, additionalParams) {
  return {
    type: WORKING_HOURS.LOAD,
    doctors: doctors,
    rooms: rooms,
    additionalParams: additionalParams
  };
};

var loadWorkingHoursDone = exports.loadWorkingHoursDone = function loadWorkingHoursDone(rooms) {
  return {
    type: WORKING_HOURS.LOAD_DONE,
    rooms: rooms
  };
};

var loadWorkingHoursFail = exports.loadWorkingHoursFail = function loadWorkingHoursFail(err) {
  return {
    type: WORKING_HOURS.LOAD_FAIL,
    err: err
  };
};

var saveWorkingHours = exports.saveWorkingHours = function saveWorkingHours(keys, reservationOptions, scheduleTypes, scheduleKey) {
  return {
    type: WORKING_HOURS.WORKING_HOURS.SUBMIT,
    keys: keys,
    reservationOptions: reservationOptions,
    scheduleTypes: scheduleTypes,
    scheduleKey: scheduleKey
  };
};

var saveWorkingHoursDone = exports.saveWorkingHoursDone = function saveWorkingHoursDone(rooms) {
  return {
    type: WORKING_HOURS.WORKING_HOURS.SUCCESS,
    rooms: rooms
  };
};

var saveWorkingHoursFail = exports.saveWorkingHoursFail = function saveWorkingHoursFail(err) {
  return {
    type: WORKING_HOURS.WORKING_HOURS.FAIL,
    err: err
  };
};

var setBranchWorkingHours = exports.setBranchWorkingHours = function setBranchWorkingHours(payload) {
  return {
    type: WORKING_HOURS.SET_BRANCH_WORKING_HOURS.SUBMIT,
    payload: payload
  };
};

var setBranchWorkingHoursSuccess = exports.setBranchWorkingHoursSuccess = function setBranchWorkingHoursSuccess(payload) {
  return {
    type: WORKING_HOURS.SET_BRANCH_WORKING_HOURS.SUCCESS,
    payload: payload
  };
};

var setBranchWorkingHoursFail = exports.setBranchWorkingHoursFail = function setBranchWorkingHoursFail(payload) {
  return {
    type: WORKING_HOURS.SET_BRANCH_WORKING_HOURS.FAIL,
    payload: payload
  };
};

var getBranchWorkingHours = exports.getBranchWorkingHours = function getBranchWorkingHours(payload) {
  return {
    type: WORKING_HOURS.GET_BRANCH_WORKING_HOURS.FETCH,
    payload: payload
  };
};

var getBranchWorkingHoursSuccess = exports.getBranchWorkingHoursSuccess = function getBranchWorkingHoursSuccess(payload) {
  return {
    type: WORKING_HOURS.GET_BRANCH_WORKING_HOURS.SUCCESS,
    payload: payload
  };
};

var getBranchWorkingHoursFail = exports.getBranchWorkingHoursFail = function getBranchWorkingHoursFail(payload) {
  return {
    type: WORKING_HOURS.GET_BRANCH_WORKING_HOURS.FAIL,
    payload: payload
  };
};